import { CustomDataTable } from 'components/customDataTable'
import { LoadingContainer } from 'components/loadingContainer'
import { PlaceholderContainer } from 'components/placeholder'
import { useCurrentAccount } from 'hooks/admin/useAuth'
import { useDeleteDialog } from 'hooks/admin/useDeleteDialog'
import { useLocationsAdmin } from 'hooks/admin/useLocations'

export interface Props {
    partnerId?: string
}

export const LocationsTable = ({ partnerId }: Props) => {
    const { currentAccount, isLoadingCurrentAccount, errorCurrentAccount } = useCurrentAccount()
    const { data, isLoading, error, tableConfig, handleEdit, handleDelete } = useLocationsAdmin(partnerId)
    const { show: showDeleteDialog, DialogComponent: DeleteDialog } = useDeleteDialog()

    return (
        <LoadingContainer isLoading={isLoading || isLoadingCurrentAccount} error={error || errorCurrentAccount}>
            {data &&
                currentAccount &&
                (data.length > 0 ? (
                    <CustomDataTable
                        tableConfig={tableConfig}
                        currentAccount={currentAccount}
                        data={data}
                        onEdit={handleEdit}
                        onDelete={handleDelete}
                        showDeleteDialog={showDeleteDialog}
                    />
                ) : (
                    <PlaceholderContainer>
                        <p>Jelenleg nincsenek helyszínek. Hozz létre újat!</p>
                    </PlaceholderContainer>
                ))}
            <DeleteDialog entityLabel={'a helyszínt'} cascadeWarning={'A törléssel minden hozzá kapcsolódó esemény is törlésre kerül.'} />
        </LoadingContainer>
    )
}
